import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { redirectToPage } from 'srcReact/helpers/history'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import { sidebarActions } from 'srcReact/components/common2/Navigation/SideBarMain/action'
import styles from './styles.module.scss'

export default function QuickCreateMenu({ isNative }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleWritePost = () => {
    redirectToPage('/0/feed')
    dispatch(sidebarActions.setCreatePostPopup(true))
  }
  const quickCreateMenuOptions = [
    {
      text: '',
      ariaLabel: t('global.alert_close'),
      icon: 'add',
      onClick: () => {},
      className: styles.closeMenu
    },
    {
      text: t('global.writePost'),
      icon: 'write',
      onClick: () => {
        handleWritePost()
      },
      className: styles.writePostMenu
    },
    {
      text: t('global.planMixr'),
      icon: 'add-to-cal',
      href: '/0/create-mixr',
      className: styles.createMenu
    },
    {
      text: t('nav.create_group'),
      icon: 'groups24',
      href: '/0/create-group',
      className: styles.createMenu
    }
  ]

  return (
    <ReactMenu
      direction='left'
      ariaLabel={t('formlabel.createMixrGroup')}
      options={quickCreateMenuOptions}
      buttonIcon='add'
      buttonIconSize='large40'
      menuButtonCSS={styles.quickCreateButton}
      menuCSS={styles.quickCreateMenu}
      menuItemCSS={styles.quickCreateMenuItem}
    />
  )
}
